module.exports = __webpack_public_path__ + "assets/img/02.afa8904d.png";